// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type {
    GetFeishuSessionsMsgHistoryQuery,
    BaseResponseListFeishuMsgFoundResponse,
} from '../../../types';

/**
 * 历史会话消息
 *
 * @export
 * @tags feishu-session-controller
 * @link [GET] /feishuSessions/msg/history
 */
export function getFeishuSessionsMsgHistory(
    options: ApiOptions<never, GetFeishuSessionsMsgHistoryQuery> & {
        params: GetFeishuSessionsMsgHistoryQuery;
    }
): Promise<BaseResponseListFeishuMsgFoundResponse> {
    return request<never, never, GetFeishuSessionsMsgHistoryQuery>('/feishuSessions/msg/history', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getFeishuSessionsMsgHistory',
    });
}

export const meta = [
    { tags: ['feishu-session-controller'], path: '/feishuSessions/msg/history', method: 'get' },
];
